(ns dre.pages.my-searches.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.network :as-alias network]
   [dre.app.router :as-alias router]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(rf/reg-event-fx
 ::init
 (fn-traced
  []
  {::router/redirect-to-handler :signals}))

(rf/reg-sub
 ::current-page
 (fn [db]
   (get-in db [:pages :current])))
